import { useEffect, useState } from "react";
import {
  DeleteSpecialEmail,
  GetSpecialEmailList,
  axiosErrorMessages,
} from "../../../../API/api";
import axios, { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import { SorterResult } from "antd/es/table/interface";
import { useAppRole } from "../../../../API/RoleContext";
import {
  Button,
  Col,
  Popconfirm,
  Row,
  Table,
  TableProps,
  Typography,
} from "antd";
// import { DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import AdminLayout from "../../../../component/AdminLayout";
import { Backdrop, CircularProgress } from "@mui/material";
import SearchBar from "../../../../component/Search";
import { customSortDirections } from "../../../../Utils/utils";
import GroupEmployeeList from "../../../../component/GroupEmployeeList";
import AddEditSpecialEmail from "../components/AddEditSpecialEmail";

type SpecialEmailList = {
  specialEmailId: number;
  email: string;
  specialEmailUsers: string[];
};
const SpecialEmailList = () => {
  const appRole = useAppRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pagesize, setPageSize] = useState<number>(50);
  const [sortedInfo, setSortedInfo] = useState<SorterResult<SpecialEmailList>>(
    {}
  );
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<SpecialEmailList[]>([]);
  const [groupList, setGroupList] = useState([]);
  const [isAddNewGroup, setIsAddNewGroup] = useState<boolean>(false);
  const [employeeList, setEmployeesList] = useState([]);
  const [isEmployeeListModalOpen, setIsEmployeeListModalOpen] =
    useState<boolean>(false);
  const [specialEmailList, setSpecialEmailList] = useState<SpecialEmailList[]>(
    []
  );
  const [isAdd, setIsAdd] = useState<boolean>(true);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    fetchSpecialEmailList();
  }, []);

  const fetchSpecialEmailList = async () => {
    try {
      setIsLoading(true);
      const response = await GetSpecialEmailList();
      setSpecialEmailList(response.data);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };
  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Special Email ID",
      dataIndex: "email",
      key: "email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
      sortOrder: sortedInfo.columnKey === "email" ? sortedInfo.order : null,
      render: (text: string) => <div>{text}</div>,
    },

    {
      title: "Employee Count",
      dataIndex: "employeeCount",
      key: "employeeCount",

      render: (text: string, record: any) => (
        <div>
          <Button
            type="link"
            disabled={record.specialEmailUsers.length === 0}
            onClick={() => handleGroupCount(record)}
          >
            {record.specialEmailUsers.length}
          </Button>
        </div>
      ),
    },
    ...(appRole
      ? [
          {
            title: "Action",
            dataIndex: "action",
            width: "20%",

            render: (_: any, record: any) => {
              return (
                <>
                  {" "}
                  <Typography.Link onClick={() => edit(record)}>
                    <EditOutlined />
                  </Typography.Link>
                  <Popconfirm
                    title="Do you want to delete the special Email ID?"
                    onConfirm={() => handleDelete(record.specialEmailId)}
                  >
                    <Typography.Link className="delete-btn">
                      <DeleteOutlined />
                    </Typography.Link>
                  </Popconfirm>
                </>
              );
            },
          },
        ]
      : []),
  ];

  const edit = (rowData: any) => {
    setIsAdd(false);
    setEditData(rowData);
    setIsAddNewGroup(true);
  };

  const handleClose = () => {
    setIsAddNewGroup(false);
    fetchSpecialEmailList();
  };

  const handleGroupCount = (text: any) => {
    setEmployeesList(text.specialEmailUsers);
    setIsEmployeeListModalOpen(true);
  };
  const handleDelete = (rowData: number) => {
    setIsLoading(true);
    DeleteSpecialEmail(rowData)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        fetchSpecialEmailList();
      })
      .catch((error: any) => {
        enqueueSnackbar("Employees assigned to this Special Email ID", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // if(error.response.data.errors.SpecialEmail[0])  {
        //   enqueueSnackbar(error.response.data.errors.SpecialEmail[0], {
        //     variant: "error",
        //     anchorOrigin: {
        //       vertical: "top",
        //       horizontal: "right",
        //     },
        //   });
        // }else {
        //   let errorMsg;
        //   if (axios.isAxiosError(error)) {
        //     const axiosError = error as AxiosError;
        //     errorMsg = axiosErrorMessages(axiosError);
        //   } else {
        //     errorMsg = error.message;
        //   }
        //   enqueueSnackbar(errorMsg, {
        //     variant: "error",
        //     anchorOrigin: {
        //       vertical: "top",
        //       horizontal: "right",
        //     },
        //   });
        // }

        setIsLoading(false);
      });
  };
  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearchText(value);
    filterData(value);
  };
  const filterData = (searchText: string) => {
    if (!searchText) {
      setFilteredData([]);
    } else {
      const filtered = specialEmailList.filter((item: any) =>
        item.email.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };
  const handleAddNewDevice = () => {
    setIsAdd(true);
    setIsAddNewGroup(true);
  };
  const handleChange: TableProps<SpecialEmailList>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<SpecialEmailList>);
    setCurrentPage(pagination.current || 1);
    setPageSize(pagination.pageSize ?? 50);
  };

  return (
    <>
      <AdminLayout>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div style={{ margin: "25px" }}>
          <div className="employee-table-header ">
            <Row gutter={16}>
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Special Email ID
                </h3>
              </Col>
              <Col className="gutter-row pm-search-flex" lg={12} sm={24}>
                <SearchBar
                  width={"50%"}
                  onSearch={handleSearch}
                  placeholder={"Search Special Email Ids"}
                />
                {appRole && (
                  <Button
                    onClick={handleAddNewDevice}
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                  >
                    Add New
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          <Table
            sortDirections={customSortDirections}
            className="status-list-admin"
            columns={columns}
            size="small"
            onChange={handleChange}
            pagination={{
              current: currentPage,
              showSizeChanger: true,
              defaultPageSize: 50,
            }}
            rowClassName="editable-row"
            dataSource={searchText ? filteredData : specialEmailList}
          />

          {isAddNewGroup && (
            <AddEditSpecialEmail
              isAdd={isAdd}
              editData={editData}
              handleClose={handleClose}
            />
          )}
        </div>
        {isEmployeeListModalOpen && (
          <GroupEmployeeList
            listData={employeeList}
            closePopup={() => setIsEmployeeListModalOpen(false)}
          />
        )}
      </AdminLayout>
    </>
  );
};
export default SpecialEmailList;
